import * as XLSX from 'xlsx-js-style'

export function isDef(v) {
  return v !== undefined && v !== null
}

/**
 * Remove an item from an array.
 */
export function remove(arr, item) {
  if (arr.length) {
    const index = arr.indexOf(item)
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

export function isRegExp(v) {
  return _toString.call(v) === '[object RegExp]'
}

export function getFileType(type) {
  const result = {}
  switch (type) {
    case 0:
      result.name = '文件夹'
      result.icon = require('@/assets/img/file-icon/0.png')
      result.type = type
      break
    case 1:
      result.name = '文档'
      result.icon = require('@/assets/img/file-icon/1.png')
      result.type = type
      break
    case 2:
      result.name = '图片'
      result.icon = require('@/assets/img/file-icon/2.png')
      result.type = type
      break
    case 3:
      result.name = '音频'
      result.icon = require('@/assets/img/file-icon/3.png')
      result.type = type
      break
    case 4:
      result.name = '视频'
      result.icon = require('@/assets/img/file-icon/4.png')
      result.type = type
      break
    case 5:
      result.name = '压缩文件'
      result.icon = require('@/assets/img/file-icon/5.png')
      result.type = type
      break
    case 6:
      result.name = 'ppt'
      result.icon = require('@/assets/img/file-icon/6.png')
      result.type = type
      break
  }
  return result
}

export function findByKey(data = [], value, props) {
  const { key, children } = props
  const stack = [...data]
  while (stack.length) {
    const item = stack.pop()
    if (item[key] == value) {
      return item
    }
    const c = item[children] || []
    if (c.length) {
      for (let i = c.length - 1; i >= 0; i--) {
        stack.push(c[i])
      }
    }
  }
  return
}


const _toString = Object.prototype.toString

export const arrayToXlsx = function (array, options = {}) {
  const columns = options.columns
  const exportData = [columns].concat(array)
  const aoa = XLSX.utils.aoa_to_sheet(exportData)

  function setColumnFontColor(opts = {}) {
    const { cell, len, color, start = 1 } = opts
    for (let i = start; i <= len; i++) {
      const currentCell = String(cell + i)
      if (aoa[currentCell]) {
        aoa[currentCell].s = { font: { color: { rgb: color } } };
        aoa[currentCell].t = "s";
      }
    }
  }

  options.generate && options.generate({ setColumnFontColor, aoa })
  const book = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(book, aoa, '第一页')
  XLSX.writeFile(book, options.fileName)
}
